import { Project, Experience, Skill } from './types';
import aetherImg from './assets/images/regenerated_image_1780181006012.webp';
import komorebiImg from './assets/images/regenerated_image_1780181194758.webp';
import aetherGallery2 from './assets/images/regenerated_image_1780181748404.webp';
import aetherGallery3 from './assets/images/regenerated_image_1780181755778.webp';
import image_1780183153409 from './assets/images/regenerated_image_1780183153409.webp';
import image_1780183160926 from './assets/images/regenerated_image_1780183160926.webp';
import image_1780183168333 from './assets/images/regenerated_image_1780183168333.webp';
import image_1780183175277 from './assets/images/regenerated_image_1780183175277.webp';
import image_1780183181439 from './assets/images/regenerated_image_1780183181439.webp';
import image_1780183187321 from './assets/images/regenerated_image_1780183187321.webp';
import image_1780261115873 from './assets/images/regenerated_image_1780261115873.webp';
import image_1780261125981 from './assets/images/regenerated_image_1780261125981.webp';
import image_1780261139624 from './assets/images/regenerated_image_1780261139624.webp';
import image_1780261142134 from './assets/images/regenerated_image_1780261142134.webp';
import komorebiGallery2 from './assets/images/regenerated_image_1780275481793.webp';
import komorebiGallery3 from './assets/images/regenerated_image_1780275491099.webp';
import komorebiGallery4 from './assets/images/regenerated_image_1780276143972.webp';
import komorebiGallery5 from './assets/images/regenerated_image_1780276150693.webp';
import komorebiGallery6 from './assets/images/regenerated_image_1780276153169.webp';
import komorebiGallery7 from './assets/images/regenerated_image_1780276155453.webp';
import novaGallery1 from './assets/images/regenerated_image_1780281146431.webp';
import novaGallery2 from './assets/images/regenerated_image_1780281149022.webp';
import novaGallery3 from './assets/images/regenerated_image_1780281151903.webp';
import novaGallery4 from './assets/images/regenerated_image_1780281435651.webp';
import novaGallery5 from './assets/images/regenerated_image_1780281439247.webp';
import novaGallery6 from './assets/images/regenerated_image_1780281442895.webp';
import novaGallery7 from './assets/images/regenerated_image_1780281446893.webp';
import novaGallery8 from './assets/images/regenerated_image_1780281451230.webp';
import novaGallery9 from './assets/images/regenerated_image_1780281779947.webp';
import novaHero from './assets/images/regenerated_image_1780291674049.webp';
import novaGallery10 from './assets/images/regenerated_image_1780291335343.webp';
import onyxHero from './assets/images/regenerated_image_1780295813041.webp';
import onyxGallery3 from './assets/images/regenerated_image_1780296469118.webp';
import onyxGallery1Rec from './assets/images/regenerated_image_1780297912781.webp';
import onyxGallery2Rec from './assets/images/regenerated_image_1780297918396.webp';
import onyxGallery5Rec from './assets/images/regenerated_image_1780297924020.webp';
import onyxGallery6 from './assets/images/regenerated_image_1780298342722.webp';
import onyxGallery4Rec from './assets/images/regenerated_image_1780298390122.webp';
import onyxGallery12 from './assets/images/regenerated_image_1780298678937.webp';
import marketingGallery1 from './assets/images/regenerated_image_1780306300819.webp';
import marketingGallery2 from './assets/images/regenerated_image_1780306322302.webp';
import marketingGallery3 from './assets/images/regenerated_image_1780306330836.webp';
import marketingGallery4 from './assets/images/regenerated_image_1780306340789.webp';
import marketingGallery5 from './assets/images/regenerated_image_1780306349666.webp';
import marketingGallery6 from './assets/images/regenerated_image_1780307439793.webp';
import marketingGallery7 from './assets/images/regenerated_image_1780307455346.webp';
import marketingHero from './assets/images/regenerated_image_1780306983915.webp';

export const projectsData: Project[] = [
  {
    id: 'aether',
    title: 'Gilgit Baltistan 4G Launch Campaign',
    category: 'Branding',
    tags: ['Brand Strategy', 'Visual Identity', 'Typography', '3D Asset Design'],
    year: '2024',
    image: aetherImg,
    description: `To develop visual assets for Zong’s Gilgit-Baltistan 4G launch as part of a multidisciplinary creative team. The objective was to deliver a high-visibility, nationwide campaign spanning both digital and OOH touchpoints.`,
    client: 'ZONG',
    role: 'Visual Designer, Motion Designer',
    challenge: `Coming from a strictly vector-centric design background, the campaign's heavy reliance on complex photo manipulation presented a steep learning curve. The project required rapidly upskilling and adapting by learning advanced manipulation techniques from senior designers.`,
    solution: `Through hands-on learning and team collaboration, I successfully executed large-scale billboards, retail collateral, and social media assets. These visual contributions are currently deployed as part of an active, nationwide campaign across Pakistan.`,
    gallery: [
      aetherImg,
      'https://www.youtube.com/shorts/xipVjqL6MbQ?feature=share',
      aetherGallery2,
      aetherGallery3,
      image_1780183153409,
      image_1780183160926,
      image_1780183168333,
      image_1780183175277,
      image_1780183181439,
      image_1780261115873,
      image_1780261125981,
      image_1780261139624,
      image_1780261142134
    ]
  },
  {
    id: 'komorebi',
    title: 'End-to-End Publication & Print Production',
    category: 'Editorial',
    tags: ['Editorial Design', 'Grid Systems', 'Color Separation', 'Offset Printing'],
    year: '2023-24',
    image: komorebiImg,
    description: 'To execute an end-to-end educational publishing project featuring 30+ fully illustrated children\'s workbooks and 30+ motion design assets. The scope covered everything from bespoke page layouts to complete print management and quality control.',
    client: 'DigCrafts',
    role: 'Editorial Designer, Motion Designer, Print Designer',
    challenge: 'Balancing a massive workload and aggressive deadlines while navigating the communication complexities of a fully remote team.',
    solution: 'Optimized our remote workflow to manage the entire pipeline—from initial layouts to final physical print delivery—ensuring all assets launched on schedule.',
    gallery: [
      komorebiImg,
      "https://www.youtube.com/watch?v=YubRkxcGyFY",
      "https://www.youtube.com/shorts/H0WqQS9omqE?feature=share",
      komorebiGallery2,
      komorebiGallery3,
      komorebiGallery4,
      komorebiGallery5,
      komorebiGallery6
    ]
  },
  {
    id: 'nova',
    title: 'Corporate Identity Suite & Product Brochures',
    category: 'Branding',
    tags: ['Identity Design', 'Brand Stationery', 'Print Production', 'Technical Layouts'],
    year: '2024',
    image: novaHero,
    description: `I designed a comprehensive corporate identity suite for UM Metals, encompassing merchandise, packaging, and extensive brand stationery. The cornerstone of this project was a series of eight highly detailed product brochures showcasing precise technical specifications.`,
    client: 'Universal Metals',
    role: 'Visual Designer, Quality Controller',
    challenge: `The primary hurdle was overhauling the existing brochure data, which was provided in an extremely poor format riddled with disorganized, error-heavy numerical tables. Extracting and restructuring this massive volume of complex technical data required meticulous attention to detail.`,
    solution: `Integrated AI tools to automate the heavy lifting of data extraction and initial table formatting. Conducted rigorous manual cross-referencing to eliminate AI-generated errors, ultimately delivering flawless, highly accurate, and modern technical layouts.`,
    gallery: [
      novaGallery10,
      novaGallery9,
      novaGallery2,
      novaGallery4,
      novaGallery5,
      novaGallery6,
      novaGallery7,
      novaGallery8
    ]
  },
  {
    id: 'onyx',
    title: 'Rawan Dawan: Experiential Brand Strategy Design',
    category: 'Branding',
    tags: ['Branding', 'Exhibition Design', 'Identity', 'Print Production'],
    year: '2025-26',
    image: onyxHero,
    description: 'For final-year thesis, jahangir conceptualized and executed Rawan Dawan, reimagined Pakistan Railways mobile museum. As a solo project, built everything from scratch, including complete branding, print materials, and train models.',
    client: 'Railway Pakistan',
    role: 'Visual Designer',
    challenge: 'The true difficulty was the rigorous, year-long conceptual research required to accurately inform the project\'s visual direction. This foundational phase demanded extensive travel, site visits, interviews, and deep data analysis.',
    solution: 'Translated this massive research effort into a cohesive visual identity and a tangible physical experience. Successfully bridged data with design, single-handedly producing every touchpoint from catalogues to 3D models.',
    gallery: [
      onyxGallery1Rec,
      onyxGallery4Rec,
      onyxGallery2Rec,
      onyxGallery3,
      onyxGallery5Rec,
      onyxGallery6,
      onyxHero,
      onyxGallery12
    ]
  },
  {
    id: 'verdant',
    title: 'Marketing Campaign',
    category: 'UI/UX',
    tags: ['Sustainable Tech', 'Mobile App', 'Prototyping', 'Earthy Tones'],
    year: '2023',
    image: marketingHero,
    description: 'Design a relatable marketing campaign for National Salt featuring posters, billboards, and social media assets. The core objective was to connect a basic, everyday staple directly with local culinary habits.',
    client: 'National Salt',
    role: 'Visual Designer',
    challenge: 'While the final visual execution was straightforward, finding the right angle required extensive data gathering. The primary hurdle was conducting deep cultural research to discover a strong, everyday consumer hook.',
    solution: 'Highlighted local tastes by photographing real salt physically shaped into familiar companion foods, like eggs, fries, and pomegranates. This minimalist approach created a clean, instantly recognizable visual connection for the audience.',
    gallery: [
      marketingGallery1,
      marketingGallery2,
      marketingGallery3,
      marketingGallery4,
      marketingGallery5,
      marketingGallery6,
      marketingGallery7
    ]
  }
];

export const experienceTimeline: Experience[] = [
  {
    id: 'exp-0',
    year: 'Present',
    role: 'Papa Johns',
    company: 'Creative Manager / Lead',
    companies: ['Creative Manager / Lead'],
    description: 'Directing creative campaigns, supervising brand identity guidelines, and leading visual design initiatives.',
    tags: ['Creative Direction', 'Lead Designer', 'Brand Management', 'Team Leadership']
  },
  {
    id: 'exp-1',
    year: 'Present',
    role: 'Independent Visual Designer',
    company: '',
    description: 'Delivering multidisciplinary solutions across video editing, motion, and static design while building a systematic foundation for independent creative projects.',
    tags: ['Creative Direction', 'Brand Strategy', 'Key Client Pitching', 'Team Mentorship']
  },
  {
    id: 'exp-2',
    year: '2024',
    role: 'The Conglo',
    company: 'Communication Designer',
    companies: ['Communication Designer'],
    description: 'At Conglo, refined static design skills and gained hands-on agency experience by collaborating with top local brands.',
    tags: ['Interface Guidelines', 'Webflow Dev', 'Micro-interactions', 'Performance Optimization']
  },
  {
    id: 'exp-3',
    year: '2023-24',
    role: 'Walled City of Lahore Authority',
    company: 'Communication Designer',
    companies: ['Communication Designer', 'Project Manager'],
    description: 'Directed teams and managed projects to create audience-targeted designs where clear communication took precedence.',
    tags: ['Cinema 4D', 'After Effects', 'Editorial Layout', 'Audio-Visual Sync']
  },
  {
    id: 'exp-4',
    year: '2022-23',
    role: 'DigCrafts Learning Alliances',
    company: 'Quality control Specialist',
    companies: [
      'Quality control Specialist',
      'Motion Designer',
      'Illustrator',
      'Post Production Editor (Video Editor)',
      'Editorial Designer'
    ],
    description: 'Directed multidisciplinary projects from management and hands-on illustration to detailed book design and expert print production.',
    tags: ['Freelance Management', 'Client Relations', 'Identity Design', 'Vector Illustration']
  },
  {
    id: 'exp-5',
    year: '2022',
    role: 'AdLooper',
    company: 'Post Production Editor (Video Editor)',
    companies: ['Post Production Editor (Video Editor)', '2D Animator'],
    description: 'Mastered professional 2D animation and high-pressure teamwork by collaborating with multidisciplinary teams of editors, illustrators, and designers.',
    tags: []
  },
  {
    id: 'exp-6',
    year: '2021',
    role: 'Kashmir Premier League',
    company: 'Post Production Editor (Video Editor)',
    companies: ['Post Production Editor (Video Editor)'],
    description: 'Delivered specialized video editing and post-production for a dedicated project with the Mirpur Royals.',
    tags: []
  }
];

export const skillsCapabilities: Skill[] = [
  {
    id: 'skill-consultancy',
    number: '01',
    title: 'Book Consultancy',
    category: 'Consultation',
    description: 'Book a dedicated 1-on-1 strategy call, motion design review, or creative direction session with Jahangir.',
    detailedDescription: 'Need professional art guidance, video hook strategies, or high-retention creative frameworks? Reserve a structured consultation session with Jahangir to design high-impact aesthetics, brand guideline assets, or 2D animation concepts and get a ready-to-execute delivery blueprint.',
    listItems: ['1-on-1 Creative Direction', 'Campaign Concept Mapping', 'Production Scope Definition', 'Custom Delivery Checklists']
  },
  {
    id: 'skill-1',
    number: '02',
    title: 'Brand Strategy & Identity',
    category: 'Branding',
    description: 'Shaping iconic, unified visual tongues that communicate across systems.',
    detailedDescription: 'Jahangir constructs thorough brand playbooks containing distinctive typography frameworks, comprehensive color theory configurations, semantic grid instructions, and dynamic visual layouts. Every asset translates core brand ideals into pristine digital layouts.',
    listItems: ['Brand Positioning & Architecture', 'Custom Logo Systems', 'Responsive Typography Schemes', 'Design Asset Standardization']
  },
  {
    id: 'skill-2',
    number: '03',
    title: 'AI Web Design & Interactive Storefronts',
    category: 'Web Design',
    description: 'Deploying ultra-fast e-commerce stores and custom web apps with buttery-smooth animations.',
    detailedDescription: 'Engineering next-generation web applications by combining intelligent AI-assisted design with advanced interactive frontend principles. Crafting highly responsive online stores and bespoke web solutions optimized for lightning-fast speeds, peak security, and highly rewarding user-focused experiences.',
    listItems: ['AI-Augmented UX Systems', 'Custom E-Commerce & Web Apps', 'Bespoke Fluid Animations', 'Speed-Optimized Implementations']
  },
  {
    id: 'skill-3',
    number: '04',
    title: 'Marketing Campaigns',
    category: 'Marketing',
    description: 'Developing high-impact visual campaigns designed to convert and leave a lasting impression.',
    detailedDescription: 'From strategy and conceptualization to full-scale visual rollout. Crafting high-conversion campaign graphics, direct-response design assets, and integrated promotional materials that align perfectly with brand core objectives and marketing KPIs.',
    listItems: ['Campaign Visual Strategy', 'Conversion-Optimized Assets', 'Multi-channel Asset Rollouts', 'Creative Direction & Ad Copies']
  },
  {
    id: 'skill-4',
    number: '05',
    title: 'Social Media Strategy & Content',
    category: 'Social Media',
    description: 'Delivering comprehensive cross-platform, scroll-stopping designs kept up to date with the latest trends.',
    detailedDescription: 'Designing specialized content optimized for X (Twitter), Threads, YouTube, Pinterest, TikTok, Instagram, Facebook, and more. Building dynamic templates, high-retention video stories, custom thumbnails, and carousel slides tailored for maximum engagement under the latest social media trends.',
    listItems: ['Cross-Platform Social Kits', 'YouTube Thumbnail & Banner Systems', 'Short-form Motion Visuals', 'Trending Content Templates']
  },
  {
    id: 'skill-5',
    number: '06',
    title: 'Editorial & Publication Design',
    category: 'Editorial',
    description: 'Styling professional publication layouts from booklets to graphic novellas.',
    detailedDescription: 'Acquiring hands-on experience by compiling extensive brand books, professional booklets, promotional catalogs, and highly detailed graphic novellas. Perfecting typography grids, margins, cover art, page counts, and interior page hierarchies.',
    listItems: ['Books & Booklet Compilations', 'Product Catalogs Layout', 'Graphic Novellas Design', 'Grid Systems & Typographic Hierarchy']
  },
  {
    id: 'skill-6',
    number: '07',
    title: 'Printing & Large Format Design',
    category: 'Print',
    description: 'Managing the end-to-end printing process from small digital print to giant billboards.',
    detailedDescription: 'Deep understanding of print-ready designs, color separations (CMYK, Pantone specs), ink processes, paper stocks, and printer capabilities. Seasoned experience in collaborating directly with printing houses and technicians to ensure impeccable final outputs.',
    listItems: ['Large-Format Billboard Design', 'CMYK & Pantone Color Prep', 'Digital & Offset Print Optimization', 'Direct Printing Press Collaboration']
  },
  {
    id: 'skill-8',
    number: '08',
    title: 'Packaging Design',
    category: 'Packaging',
    description: 'Developing professional structural dielines, 3D mockups, and retail-ready packaging systems.',
    detailedDescription: 'Crafting bespoke packaging concepts, folding carton structures, custom dielines, and high-fidelity 3D volume mockups. Every layout is calibrated for exact physical production, manufacturing specs, material textures, substrate finishes, and high-impact shelf presentation.',
    listItems: ['Custom Dielines & Structural Design', '3D Retail & Box Mockups', 'Substrate & Finish Definition', 'Production-Ready Package Layouts']
  }
];

